export const BRAND = {
  title: 'ICECAT 1',
  shortTitle: 'ICECAT 1',
  eyebrow: 'THE FROST-FRUIT ARCADE',
  tagline: 'Shape the snow. Outsmart the storm.',
  rally: 'Dash. Gather. Shape. Escape.',
  campaignMazeCount: 10,
  flavorCount: 4,
  fruitFamilyCount: 10,
  collectibleSingular: 'Frozen Fruit',
  collectiblePlural: 'Frozen Fruits',
  wallName: 'Frostwall',
  wallNamePlural: 'Frostwalls',
  exitName: 'Snowgate',
  shardName: 'Sugar Shard',
  storageKey: 'icecat-1-save',
  legacyStorageKeys: ['rift-rascals-save'],
  version: 3,
} as const;

export const COLORS = {
  void: 0x070b1f,
  navy: 0x101936,
  cyan: 0x4eeaff,
  teal: 0x20d7c5,
  coral: 0xff6f7f,
  violet: 0x9d6cff,
  lime: 0xc8ff61,
  cream: 0xf4f7ff,
  danger: 0xff4778,
} as const;
